import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import { FiCalendar, FiEdit3, FiAward } from 'react-icons/fi';

// Assuming images are accessible, or use placeholders/icons for now if imports fail
// Ideally, we move the images to `src/assets` or use public folder. 
// For now, I'll use placeholders or the existing import paths if I can guess them, 
// but reusing the exact imports from a different folder structure is risky without strict paths.
// I will use nice colored avatars/icons for now to ensure it looks good immediately.

const exams = [
    { title: "JEE Main 2025", date: "02 Apr 25", app: "01 Feb 25", color: "bg-blue-500" },
    { title: "NEET UG 2025", date: "05 May 25", app: "01 Mar 25", color: "bg-green-500" },
    { title: "GATE 2025", date: "03 Feb 25", app: "24 Aug 24", color: "bg-orange-500" },
    { title: "CAT 2025", date: "24 Nov 25", app: "02 Aug 25", color: "bg-purple-500" },
    { title: "CLAT 2025", date: "01 Dec 24", app: "01 Jul 24", color: "bg-red-500" },
    { title: "UPSC CSE 2025", date: "26 May 25", app: "01 Feb 25", color: "bg-indigo-500" },
    { title: "BITSAT 2025", date: "22 May 25", app: "10 Jan 25", color: "bg-teal-500" },
    { title: "XAT 2025", date: "05 Jan 25", app: "15 Jul 24", color: "bg-pink-500" }
];

const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 4 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
};

const ExamSection = () => {
    return (
        <section className="py-20 bg-gray-50 relative z-10">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="mb-12">
                        <h2 className="text-3xl font-bold text-gray-800">Entrance Exams <span className="text-brand-orange">In India</span></h2>
                        <div className="w-24 h-1 bg-brand-orange mt-2 rounded-full"></div>
                    </div>

                    {/* Carousel with low z-index buttons */}
                    <div className="relative">
                        <style>{`
                            .exam-carousel .react-multiple-carousel__arrow {
                                z-index: 10 !important;
                            }
                            .exam-carousel .react-multiple-carousel__arrow:hover {
                                background: rgba(0, 0, 0, 0.8) !important;
                            }
                        `}</style>
                        <Carousel
                            responsive={responsive}
                            infinite
                            autoPlay
                            autoPlaySpeed={3000}
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            containerClass="exam-carousel"
                            itemClass="px-3"
                        >
                            {exams.map((exam, index) => (
                                <div key={index} className="bg-gray-50 rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                                    <div className="flex items-center gap-4 mb-6">
                                        <div className={`w-12 h-12 rounded-xl ${exam.color} text-white flex items-center justify-center font-bold text-xl uppercase`}>
                                            {exam.title.charAt(0)}
                                        </div>
                                        <h3 className="font-bold text-lg text-gray-800 leading-tight">{exam.title}</h3>
                                    </div>

                                    <div className="space-y-3 mb-6">
                                        <div className="flex items-center text-sm text-gray-600">
                                            <FiCalendar className="mr-2 text-brand-orange" />
                                            <span><span className="font-semibold">Exam:</span> {exam.date}</span>
                                        </div>
                                        <div className="flex items-center text-sm text-gray-600">
                                            <FiEdit3 className="mr-2 text-brand-orange" />
                                            <span><span className="font-semibold">App:</span> {exam.app}</span>
                                        </div>
                                    </div>

                                    <Link to="/contact" className="block w-full text-center py-2 rounded-lg border border-brand-orange text-brand-orange font-semibold hover:bg-brand-orange hover:text-white transition">
                                        Apply Now
                                    </Link>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExamSection;
